import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import HeroGetQuoteInput from '../../components/HeroGetQuoteInput';
import jkSimmonsImg from '../../assets/img/JKSimmons.png';
import { ReactComponent as CheckIcon } from '../../assets/img/icon-font-awesome-check.svg';

const useStyles = makeStyles((theme) => {
  const {
    palette: { tenant },
    breakpoints,
  } = theme;

  return {
    boxHeader: {
      fontSize: 32,
      [breakpoints.up('sm')]: {
        fontSize: 40,
      },
    },
    boxSubHeader: {
      fontSize: 20,
      marginBottom: 10,
    },
    boxSubtitle: {
      fontSize: 14,
      [breakpoints.up('sm')]: {
        fontSize: 16,
      },
    },
    heroContainer: {
      [breakpoints.up('lg')]: {
        display: 'flex',
      },
    },
    heroImg: {
      alignSelf: 'flex-end',
      width: 541,
      height: 555,
    },
    boxContainer: {
      backgroundColor: tenant.white,
      maxWidth: 480,
      margin: '48px auto',
      minWidth: 280,
      padding: 24,
      [breakpoints.up('sm')]: {
        padding: '32px 48px',
      },
    },
    iconAdjust: {
      verticalAlign: 'middle',
      marginRight: 5,
    },
  };
});

function HeroQuoteCard({ classes }) {
  return (
    <Paper className={classes.boxContainer} elevation={0}>
      <Typography
        variant="h3"
        color="primary"
        className={classes.boxHeader}
        gutterBottom
      >
        Auto Insurance in South Carolina
      </Typography>
      <Typography variant="h4" className={classes.boxSubHeader}>
        Farmers&reg; auto policies can include benefits like:
      </Typography>
      <Typography
        variant="subtitle1"
        className={classes.boxSubtitle}
        paragraph={true}
      >
        <CheckIcon color="secondary" className={classes.iconAdjust} />
        Personalized coverage options
      </Typography>
      <Typography
        variant="subtitle1"
        className={classes.boxSubtitle}
        paragraph={true}
      >
        <CheckIcon color="secondary" className={classes.iconAdjust} />
        Towing and roadside assistance
      </Typography>
      <Typography
        variant="subtitle1"
        className={classes.boxSubtitle}
        paragraph={true}
        gutterBottom
      >
        <CheckIcon color="secondary" className={classes.iconAdjust} />
        Discounts
      </Typography>
      <Typography variant="h4">Get an auto insurance quote</Typography>
      <HeroGetQuoteInput />
    </Paper>
  );
}

function LandingHero() {
  const classes = useStyles();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  return (
    <Container className={classes.heroContainer}>
      <HeroQuoteCard classes={classes} />
      {isDesktop && (
        <img
          className={classes.heroImg}
          src={jkSimmonsImg}
          alt="Farmers Insurance Spokesperson, J.K. Simmons"
        />
      )}
    </Container>
  );
}

export default LandingHero;
